"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Calculate the details of the birthday.
 * @param date Birthday.
 */
exports.default = (date) => {
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    const early = (containFebrary = true) => month === 1 || (month === 2 && containFebrary) ? 1 : 0;
    return {
        date: date.getDate(),
        month: { early, month, shifted: month + early() * 12 },
        year: { full: year, hi: Math.floor(year * 0.01), lo: year % 100 },
    };
};
//# sourceMappingURL=getBirthdayDetails.js.map